export class FiltroModel {
  pagina: number;
  itensPorPagina: number;
  direcao: string;
  colunaOrder: string;
  pesquisa = '';
  ativo: boolean;
 }
